import React from 'react';
import 'twin.macro';
import Card from '@teetsh/app/src/components/Card';

export interface NewOptionCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  onClick: () => void;
}

export function NewOptionCard(props: NewOptionCardProps) {
  const { title, description, icon, onClick } = props;
  return (
    <Card
      tw="p-4! lg:pt-8! grid items-center justify-center grid-cols-5 lg:grid-cols-1 lg:grid-rows-3 gap-4 lg:gap-x-0 rounded-lg! border-transparent! hover:border-neutral-moderate!"
      interactive
      onClick={onClick}
    >
      <div tw="col-span-3">
        <h2 tw="mb-1 lg:mb-2.5 text-xl md:text-2xl">{title}</h2>
        <div tw="text-neutral-quiet text-sm lg:text-base">{description}</div>
      </div>
      <div tw="col-span-2 lg:row-span-2 inline-flex justify-center items-center [&_svg]:h-auto">
        {icon}
      </div>
    </Card>
  );
}
